export enum LanguageEnum {
    TELUGU = 'TELUGU',
    ENGLISH = 'ENGLISH',
    URDU = 'URDU',
    HINDI = 'HINDI'
}